export const name = 'ks/config';

export const FETCH_REQUEST = `${name}/fetch/request`;
export const FETCH_SUCCESS = `${name}/fetch/success`;
export const FETCH_FAILURE = `${name}/fetch/failure`;